module.exports = __webpack_public_path__ + "static/img/价值理念.1f553b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/价值理念.png
// module id = x2DU
// module chunks = 13